<div class="container">
  <mat-tab-group #tabGroup mat-stretch-tabs mat-align-tabs="center">
    <mat-tab [label]="'generic.details' | translate">
        @if (survey_id) {
          <app-survey-details
            [surveyId]="survey_id"
            (canceled)="backToProject($event)"
            (surveyChanged)="onSurveyChanged($event)"
            [noButtons]="noButtons"
            />
        }
    </mat-tab>
    @if (survey && !survey?.is_draft) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'components.responses.responses' | translate }}</span>
          @if (survey?.status == 'EVALUATING') {
            <mat-icon
              [ngStyle]="{'color': '#f44336'}"
              class="ml-2">notifications
            </mat-icon>
          }
        </ng-template>
        <app-survey-all-responses
          [surveyId]="survey_id"
          [survey]="survey"
          #allResponsesComponent>
        </app-survey-all-responses>
      </mat-tab>
    }
    @if (survey?.visibility_type === 'PRIVATE' && !survey?.is_draft) {
      <mat-tab [label]="'generic.team' | translate">
        <app-survey-team [members]="survey?.members" [surveyId]="survey_id" [surveyIsClosed]="survey?.status == 'CLOSED'"/>
      </mat-tab>
    }
    @if (survey && consensusQuestionsExist && survey?.answers_sent > 0) {
      <mat-tab [label]="'modals.modal-survey-details.revisions-management' | translate"
        >
        @if (survey) {
          <app-survey-dashboard [survey]="survey"/>
        }
      </mat-tab>
    }
    @if (survey && survey?.history_surveys_count > 1) {
      <mat-tab [label]="'modals.modal-survey-details.survey-tree' | translate">
        <app-survey-tree [survey]="survey" (surveyNodeClicked)="surveyNodeCLicked($event)"/>
      </mat-tab>
    }
    @if (survey && consensusQuestionsExist) {
      <mat-tab [label]="'generic.questions-dashboard' | translate">
        <app-survey-questions-dashboard [survey]="survey"/>
      </mat-tab>
    }
  </mat-tab-group>
</div>
